import { i18n } from '@/plugins/i18n';
import * as validators from '@vuelidate/validators';

const { createI18nMessage } = validators;

export const withI18n = createI18nMessage({
    // @ts-ignore the functions have the same signature, but their types don't match
    t: i18n.t,
    messagePath: ({ $validator }) => `errors.input.validation:${$validator}`,
});

export const required = withI18n(validators.required);

export const requiredIf = withI18n(validators.requiredIf, { withArguments: true });

export const email = withI18n(validators.email);

export const minLength = withI18n(validators.minLength, { withArguments: true });

export const maxLength = withI18n(validators.maxLength, { withArguments: true });

export const noSpecialChars = validators.helpers.withMessage(
    () => i18n.t('errors.input.validation.noSpecialChars', 'error'),
    (value: string) => !/[/\\:*?"<>|]/.test(value),
);
